import * as React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import getAllItemViewsByType from 'checkout/selectors/view/getAllItemViewsByType'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import { ENABLED_TRIP_RESTORE_CART_CHECKOUT_ITEMS } from 'tripPlanner/config'
import {
  shouldShowTripPlannerSaveEntryPoints,
} from 'tripPlanner/hooks/useShouldShowTripPlannerSaveEntryPoints'
import config from 'constants/config'

interface Props {
  canSaveToTrip: boolean
  children: React.ReactNode
}

const possiblePaths = [
  '/:regionCode/checkout/review',
  '/:regionCode/checkout/:cartId/purchase',
]

function CheckoutSaveButtonGuard({ canSaveToTrip, children }: Props) {
  if (!canSaveToTrip) return null
  return (
    <>
      {possiblePaths.map((path) => (
        <Route key={path} path={path}>
          <TripGuard>{children}</TripGuard>
        </Route>
      ))}
    </>
  )
}

function mapStateToProps(state: App.State) {
  const checkoutItems = state.checkout.cart.items
  const hasMultiCityFlight = checkoutItems.some(item =>
    item.itemType === 'flight' && item.fareType === 'multiCity',
  )
  const shouldShowSaveEntryPoints = shouldShowTripPlannerSaveEntryPoints(
    state.router.location.pathname,
    config.ENABLE_TRIP_PLANNER,
  )
  const canSaveToTrip =
    shouldShowSaveEntryPoints &&
    checkoutItems.length > 0 &&
    !hasMultiCityFlight &&
    checkoutItems.every((item) =>
      ENABLED_TRIP_RESTORE_CART_CHECKOUT_ITEMS.has(item.itemType),
    ) &&
    getAllItemViewsByType(state).hasRequiredData

  return {
    canSaveToTrip,
  }
}

export default connect(mapStateToProps)(CheckoutSaveButtonGuard)
